(() => {
  // src/product-parallax-notes.ts
  (() => {
    const typewriteDesc = (desc) => {
      const html = desc.innerHTML;
      const lines = html.split(/<br\s*\/?>/i);
      desc.innerHTML = lines.map(
        () => `<span class="pn-tw-line"><span class="pn-tw-text"></span></span>`
      ).join("<br>");
      const lineEls = Array.from(desc.querySelectorAll(".pn-tw-text"));
      const CHAR_DELAY = 10;
      const LINE_GAP = 100;
      let globalOffset = 0;
      lines.forEach((line, li) => {
        const text = line.replace(/<[^>]+>/g, "");
        const lineEl = lineEls[li];
        const chars = Array.from(text);
        chars.forEach((ch, ci) => {
          const delay = globalOffset + ci * CHAR_DELAY;
          setTimeout(() => {
            lineEl.textContent += ch;
          }, delay);
        });
        globalOffset += chars.length * CHAR_DELAY + LINE_GAP;
      });
    };
    const initParallaxNotes = (section) => {
      var _a;
      const items = Array.from(
        section.querySelectorAll(".product-parallax-notes__item")
      );
      if (!items.length) return;
      const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;
      section.classList.add("pn-js");
      let ticking = false;
      const easeInOutQuad = (t) => t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      const update = () => {
        const vh = window.innerHeight;
        items.forEach((item, i) => {
          const rect = item.getBoundingClientRect();
          const rawProgress = Math.max(
            0,
            Math.min(1, (vh - rect.top) / (vh * 2))
          );
          item.style.backgroundPositionY = 35 + rawProgress * 30 + "%";
          if (i < items.length - 1) {
            const nextRect = items[i + 1].getBoundingClientRect();
            const coverP = Math.max(0, Math.min(1, 1 - nextRect.top / vh));
            const easedCover = coverP * coverP * (3 - 2 * coverP);
            item.style.filter = `brightness(${1 - easedCover * 0.45})`;
          }
          if (!prefersReducedMotion) {
            const enterP = Math.max(0, Math.min(1, 1 - rect.top / (vh * 0.7)));
            const eased = easeInOutQuad(enterP);
            const title = item.querySelector(".product-parallax-notes__title");
            const desc = item.querySelector(
              ".product-parallax-notes__description"
            );
            if (title) {
              title.style.opacity = String(eased);
              title.style.transform = `translateY(${(1 - eased) * 120}px)`;
            }
            if (desc) {
              const descP = Math.max(0, Math.min(1, (enterP - 0.15) / 0.85));
              const easedDesc = easeInOutQuad(descP);
              desc.style.opacity = String(easedDesc);
              desc.style.transform = `translateY(${(1 - easedDesc) * 120}px)`;
              if (!item.dataset.twDone && descP >= 0.25) {
                item.dataset.twDone = "1";
                typewriteDesc(desc);
              }
            }
          }
        });
        ticking = false;
      };
      const onScroll = () => {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      };
      const scrollTarget = (_a = section.closest(".page-preview-modal__body")) != null ? _a : window;
      scrollTarget.addEventListener("scroll", onScroll, {
        passive: true
      });
      update();
    };
    document.querySelectorAll(".product-parallax-notes:not([data-pn-init])").forEach((el) => {
      el.setAttribute("data-pn-init", "");
      initParallaxNotes(el);
    });
    window.HotelCollection = window.HotelCollection || {};
    window.HotelCollection.initParallaxNotes = (scope) => {
      scope.querySelectorAll(
        ".product-parallax-notes:not([data-pn-init])"
      ).forEach((el) => {
        el.setAttribute("data-pn-init", "");
        initParallaxNotes(el);
      });
    };
  })();
})();
